import { Box, BoxProps, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Markdown } from '~/components/markdown';
import { Rating } from '~/components/rating';

import { EnterpriseResourceReview } from '../models/enterprise-report-content';

export function EnterpriseResourceReviewCard({ review, ...props }: { review: EnterpriseResourceReview } & BoxProps) {
  return (
    <Card backgroundColor='blue.700' height='100%' padding='40px 32px' width='100%' {...props}>
      <Rating rating={review.rating} size='md' />

      <Text color='white' fontSize='12px' marginTop='8px'>
        {review.date}
      </Text>

      <Box color='white' fontWeight='600' marginY='40px'>
        <Markdown markdownText={review.reviewContent} />
      </Box>

      <Text color='white' fontWeight='600'>
        {review.person.name}
      </Text>
      <Text color='white' fontSize='12px'>
        {review.person.title}
      </Text>
    </Card>
  );
}
